// Cloudflare Images exige um sufixo de variant (ex.: `/public`) — sem ele a URL
// 404. Aqui normalizamos sempre pra `/public` (teto de qualidade, igual ao resto
// do app: useRibbon / useResponsiveBannerUrl).
//
// Só age em URLs do Cloudflare (imagedelivery.net); qualquer outra volta como
// veio. Remove uma variant já presente antes de reaplicar, pra não duplicar
// (`.../public/public`).
const CLOUDFLARE_HOST = 'imagedelivery.net';
const CLOUDFLARE_VARIANT_RE = /\/(public|mobile|ipad)$/;

export function resolveCloudflareImage(url?: string | null): string {
  if (!url) return '';

  // Checa o host de verdade (via URL.hostname), não um substring solto: senão
  // `evil.com/imagedelivery.net` ou `imagedelivery.net.evil.com` passariam.
  let hostname: string;

  try {
    hostname = new URL(url).hostname;
  } catch {
    return url;
  }

  const isCloudflareHost =
    hostname === CLOUDFLARE_HOST || hostname.endsWith(`.${CLOUDFLARE_HOST}`);

  if (!isCloudflareHost) return url;

  const base = url.replace(CLOUDFLARE_VARIANT_RE, '');

  return `${base}/public`;
}
